import {
  RadioButton,
  RadioButtonGroup,
  RadioButtonGroupProps,
} from '@idexx-laboratories/spot-react';
import React from 'react';

interface RadioButtonValueGroupProps extends Omit<RadioButtonGroupProps, 'onChange'> {
  small?: boolean;
  values: Readonly<any[]>;
  displayField?: string;
  onChange: (index: number) => void;
  checkedIndex: number;
  formatter?: (v: any) => string;
  allDisabled?: boolean;
  disabledByIndex?: (index: number) => boolean;
  elementsClass?: string;
}

const RadioButtonValueGroup = (props: RadioButtonValueGroupProps): React.JSX.Element => {
  const {
    small,
    values,
    displayField,
    onChange,
    formatter,
    checkedIndex,
    elementsClass,
    allDisabled,
    disabledByIndex,
    ...rest
  } = props;

  const formatValue = value =>
    formatter ? formatter(value) : displayField ? value[displayField] : value;

  return (
    <RadioButtonGroup {...rest}>
      {values.map((value, index) => (
        <RadioButton
          id={`${rest.id}__${index}`}
          label={formatValue(value)}
          className={elementsClass}
          aria-label={formatValue(value)}
          key={displayField ? value[displayField] : value}
          checked={checkedIndex === index}
          disabled={allDisabled || disabledByIndex?.(index) || false}
          onChange={e => e.target.checked && onChange(index)}
          size={small ? 'small' : 'default'}
          data-testid={`${rest['data-testid']}-${formatValue(value)}-rb`}
        ></RadioButton>
      ))}
    </RadioButtonGroup>
  );
};

export default RadioButtonValueGroup;
